<template>
    <div class="article-detail" id="FixedPosition">
        <div class="comment_box">
            <div class="date">
                <div class="value">{{ data.created }}</div>
                <div class="arrow_date"></div>
            </div>
            <div class="comments_number">{{ data.comments ? data.comments.length + 1 : 0 }} Комментарии</div>
        </div>
        <div class="article-detail__content">
            <div class="article-detail-top">
                <div class="article-detail__title">
                    <h2>{{ data.title }}</h2>
                </div>
                <router-link v-if="data.photo" tag="div"
                             :to="$route.name === 'Новости' ? {name: 'articleDetail', params: {title: data.slug}} : {}"
                             class="article-detail__image">
                    <img :src="data.photo ? data.photo.full_size: ''" :alt="data.title">
                </router-link>
            </div>

            <div class="article-detail__desc">
                <div style="padding: 10px 0" v-html="data.description"></div>
<!--                <a v-if="$route.name !== 'Новости'" @click="animateScroll" class="more-detail"> Оставить комментарий-->
<!--                    →</a>-->
<!--                <router-link :to="{name: 'articleDetail', params: {title: data.slug}}" v-if="$route.name === 'Новости'"-->
<!--                             class="more-detail"> Подробнее →-->
<!--                </router-link>-->

<!--                <ul class="routes">-->
<!--                    <li :key="tag.id" v-for="tag in data.tags">-->
<!--                        <a :href="tag.url">{{ tag.title }}</a>-->
<!--                    </li>-->
<!--                </ul>-->
            </div>
<!--            <div class="comment-container" v-if="data.comments && data.comments.length">-->
<!--                <div class="comments_number">{{ data.comments ? data.comments.length : 0 }} Комментарии</div>-->
<!--                <div class="comment-item" :key="comment.id" v-for="comment in data.comments">-->
<!--                    <div class="comment_author_avatar">-->
<!--                        <img :alt="comment.name"-->
<!--                             src="http://1.gravatar.com/avatar/d36baf1bc706f6102e421800b5c57d52?s=73&amp;d=mm&amp;r=g">-->
<!--                    </div>-->
<!--                    <div class="comment_details">-->
<!--                        <div class="posted_by">-->
<!--                            Сообщение {{ comment.name }} {{ comment.created }}-->
<!--                        </div>-->
<!--                        <p>{{ comment.body }}</p>-->
<!--                        <a @click="animateScroll" class="more-detail">-->
<!--                            Ответить → </a>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->
        </div>

    </div>
</template>

<script>
import animateScrollTo from "animated-scroll-to";

export default {
    name: "article-detail-component",
    components: {
        animateScrollTo
    },
    props: ["data", "routeName"],
    methods: {
        animateScroll() {
            animateScrollTo(document.getElementById("comment-form"))
        },

        scrollToImage() {
            let fixedPosition = document.getElementById("FixedPosition");
            fixedPosition.scrollIntoView()
        }
    },

    mounted() {
        this.scrollToImage();
    }
}
</script>

<style lang="scss" scoped>
.article-detail {
    display: flex;
    margin-top: 30px;

    @media screen and (max-width: 570px) {
        flex-direction: column;
        align-items: flex-start;
    }

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        @media screen and(max-width: 570px) {
            flex-direction: row;
            width: 250px;

            .date {
                margin-right: 10px;
            }

            .value, .comments_number {
                margin-top: 0;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;

            @media screen and(max-width: 570px) {
                top: unset;
                right: unset;
                left: 0;
                bottom: -4px;
            }
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;
        width: 70%;

        .article-detail-top {
            cursor: pointer;
        }

        @media screen and (max-width: 570px) {
            margin-left: 0;
        }
        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    &__title {
        text-align: left;
        margin-bottom: 10px;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        width: 70%;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            margin: 5px 20px 20px 0;
        }

        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    &__desc {
        text-align: left;

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }

        p {
            padding-bottom: 1em;
        }
    }
}

.comment-wrapper {
    margin-left: 120px;
    margin-top: 30px;
    padding: 10px;
}

.comment-container {
    position: relative;

    .comments_number {
        position: absolute;
        left: -100px;
        width: 85px;

        @media screen and (max-width: 570px) {
            position: unset;
        }
    }
}

.comments_number {
    width: 100%;
    margin-top: 4px;
    background-color: #00b6cc;
    padding: 6px 10px;
    color: #fff;
    font-size: 11px;
    text-align: center;
}

.comment-item {
    display: flex;
    padding: 30px 0;

}

.comment-item:not(:last-child) {
    border-bottom: 1px solid #E0E0E0;
}

.posted_by {
    font-size: 11px;
    color: #909090;
}

.comment-item p {
    color: #666;
    line-height: 150%;
    font-size: 12px;
    padding: 15px 0;
}

.comment_details {
    text-align: left;
    padding-left: 30px;
}
</style>
